$(() => {
  $('[data-toggle="tooltip"]').tooltip();
});
